export * from './type';
export * from './icon';
export { provideIcons } from './providers';
export type { IconMode, IconsConfig } from './providers';
